module.exports = __webpack_public_path__ + "img/logo-text.71980d2d.png";